import { Baby, Banknote, Bed, Beer, BookOpen, Building, Building2, Church, CircleDot, Clapperboard, Coffee, DoorOpen, Dumbbell, Footprints, Fuel, GraduationCap, HeartPulse, Home, Hospital, Hotel, Landmark, MapPin, Mountain, Pill, Sandwich, Scissors, Shield, ShoppingBag, Smile, Store, Tent, TreePine, Trees, Trophy, Utensils, Waves } from "lucide-react";
const ICON_MAP = {
  utensils: Utensils,
  coffee: Coffee,
  beer: Beer,
  sandwich: Sandwich,
  trees: Trees,
  "tree-pine": TreePine,
  mountain: Mountain,
  waves: Waves,
  footprints: Footprints,
  landmark: Landmark,
  "building-2": Building2,
  clapperboard: Clapperboard,
  "book-open": BookOpen,
  church: Church,
  dumbbell: Dumbbell,
  trophy: Trophy,
  baby: Baby,
  "circle-dot": CircleDot,
  bed: Bed,
  hotel: Hotel,
  tent: Tent,
  home: Home,
  "heart-pulse": HeartPulse,
  hospital: Hospital,
  pill: Pill,
  smile: Smile,
  store: Store,
  "shopping-bag": ShoppingBag,
  banknote: Banknote,
  scissors: Scissors,
  fuel: Fuel,
  building: Building,
  "graduation-cap": GraduationCap,
  shield: Shield,
  "door-open": DoorOpen
};
export function getCategoryIcon(iconName) {
  if (!iconName) return MapPin;
  return ICON_MAP[iconName] ?? MapPin;
}

// Parent category slug → tailwind bg/text color classes
export const CATEGORY_COLOR_CLASSES = {
  "mat-dryck": {
    bg: "bg-red-100",
    text: "text-red-600"
  },
  natur: {
    bg: "bg-green-100",
    text: "text-green-600"
  },
  kultur: {
    bg: "bg-purple-100",
    text: "text-purple-600"
  },
  "sport-fritid": {
    bg: "bg-orange-100",
    text: "text-orange-600"
  },
  boende: {
    bg: "bg-blue-100",
    text: "text-blue-600"
  },
  halsa: {
    bg: "bg-pink-100",
    text: "text-pink-600"
  },
  service: {
    bg: "bg-yellow-100",
    text: "text-yellow-600"
  },
  offentligt: {
    bg: "bg-slate-100",
    text: "text-slate-600"
  }
};
export const DEFAULT_COLOR_CLASS = {
  bg: "bg-indigo-100",
  text: "text-indigo-600"
};